import React, { useEffect, useState } from "react";

import { apiGet, apiPost } from "../Api/Client.js";
import { Badge, Button, Card, Page, PageHeader } from "../Ui/index.jsx";

// One shared page for every product the company has switched off (plugin platform).
// Shown instead of the product's screen when its address is opened, so a person
// learns why it is not there and who can add it, rather than being bounced to Home.
// The company admin (Plan and Plugins, update) can switch it on right here, within
// the company's plan. A video slot is reserved for a short product walkthrough.
export function NotInPlanScreen({ productCode, navigate, onPluginsChanged }) {
  const [catalogue, setCatalogue] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    apiGet("/EnterpriseCore/plugins/")
      .then((res) => { if (alive) setCatalogue(res); })
      .catch(() => { if (alive) setCatalogue(null); });
    return () => { alive = false; };
  }, [productCode]);

  const product = (catalogue?.plugins || []).find((p) => p.code === productCode) || null;
  const name = product?.name || "This product";

  const enable = async () => {
    setBusy(true);
    setError("");
    try {
      await apiPost(`/EnterpriseCore/plugins/${encodeURIComponent(productCode)}/state/`, { state: "enabled", reason: "Switched on from the product page" });
      if (onPluginsChanged) onPluginsChanged();
    } catch (err) {
      setError(err?.payload?.message || err?.message || "Could not switch it on.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Page>
      <PageHeader
        eyebrow="Not part of your plan"
        title={name}
        subtitle={product?.summary || "Your company has not switched this on."}
      />
      <Card
        title={product?.inPlan ? "Your plan includes this" : "Not in your current plan"}
        subtitle={product?.canToggle
          ? "You can switch it on for your company. Your data is kept while it is off."
          : "Ask your company's admin to add it. Anything your company already stored here is kept."}
        actions={<Badge variant={product?.inPlan ? "info" : "warning"} dot>{product?.inPlan ? "Available" : "Upgrade"}</Badge>}
      >
        <div className="ds-toolbar" style={{ gap: 12, marginTop: 8 }}>
          {product?.canToggle && (
            <Button variant="primary" onClick={enable} disabled={busy}>
              {busy ? "Switching on…" : `Switch on ${name}`}
            </Button>
          )}
          <Button variant="ghost" onClick={() => navigate && navigate("/home/")}>Back to Home</Button>
        </div>
        {error && <p className="ds-field__error" style={{ marginTop: 12 }}>{error}</p>}
      </Card>
    </Page>
  );
}

export default NotInPlanScreen;
